import { PersonImage } from '../../basic';
import React from 'react';
import { intl } from '../../../lib';

type StatusProps = {
  state?: 'online' | 'unavailable' | 'offline';
  userStatusId: string;
};
const Status = ({ state, userStatusId }: StatusProps) => {
  if (state) {
    let ariaLabel;
    switch (state) {
      case 'online':
        ariaLabel = intl('common.userOnline');
        break;
      case 'unavailable':
        ariaLabel = intl('common.userUnavailable');
        break;
      case 'offline':
        ariaLabel = intl('common.userOffline');
        break;
      default:
        ariaLabel = '';
    }
    return (
      <div
        className={['badge', state].join(' ')}
        role="status"
        aria-label={ariaLabel}
        id={userStatusId}
      ></div>
    );
  } else return <></>;
};

export type ChatPersonImageProps = {
  firstname?: string;
  lastname?: string;
  avatar: 'group' | 'user';
  userStatus?: 'online' | 'unavailable' | 'offline';
  image?: string;
  userStatusId?: string;
};
export const ChatPersonImage = ({
  firstname,
  lastname,
  avatar,
  userStatus,
  image,
  userStatusId
}: ChatPersonImageProps) => {
  return (
    <div className="ehs-chat-person-image">
      <PersonImage
        emptyState={avatar === 'group' ? 'user-group' : 'user-3'}
        firstName={firstname}
        lastName={lastname}
        scale="small"
        image={image}
      />
      {userStatus && (
        <Status state={userStatus} userStatusId={userStatusId ?? ''} />
      )}
    </div>
  );
};
